import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LogoComponent, MenuComponent } from '@app/shared';

@Component({
    selector: 'app-sidebar',
    imports: [LogoComponent, TranslatePipe, MenuComponent],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
    readonly borderless = input(false);
}
